<div class="auth-wrapper">
  <div class="auth-card">
    <div class="brand">
      <span class="brand-icon">
        <svg width="70" height="70" viewBox="0 0 70 70" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M31.33 50.815H24.33C23.9825 50.8077 23.6429 50.71 23.3447 50.5315C23.0464 50.353 22.7999 50.0999 22.6293 49.7971C22.4587 49.4942 22.3699 49.1522 22.3718 48.8046C22.3737 48.457 22.4661 48.116 22.64 47.815L33.31 29.685C33.4899 29.3978 33.7398 29.161 34.0363 28.9969C34.3328 28.8327 34.6661 28.7466 35.005 28.7466C35.3439 28.7466 35.6772 28.8327 35.9737 28.9969C36.2702 29.161 36.5201 29.3978 36.7 29.685L47.35 47.855C47.5239 48.156 47.6163 48.497 47.6182 48.8446C47.6201 49.1922 47.5313 49.5342 47.3607 49.8371C47.1901 50.1399 46.9436 50.393 46.6453 50.5715C46.3471 50.75 46.0075 50.8477 45.66 50.855H38.38V57.305H61.11L35.01 12.695L8.89 57.265H31.33V50.815Z"/>
        </svg>
      </span>
      <div>
        <div class="brand-name">ZestyPOS</div>
        <small class="brand-tagline">Secure login powered by Trangle Identity</small>
      </div>
    </div>

    @if (!hasError) {
      <div class="status">
        <div class="spinner"></div>
        <p>{{ statusMessage }}</p>
      </div>
    } @else {
      <div class="status error">
        <p>{{ statusMessage }}</p>
        <button type="button" (click)="retry()">Try again</button>
      </div>
    }

  </div>
</div>
